import React from 'react';
import cn from 'classnames';
import {t} from '@lingui/core/macro';

import Delete from 'shared/ui/icons/General/Delete';

import styles from './RemoveFieldButton.module.scss';

interface IRemoveFieldButtonProps {
    onRemove: () => void;
    floating?: boolean;
}

const RemoveFieldButton: React.FC<IRemoveFieldButtonProps> = ({onRemove, floating}) => (
    <button
        type="button"
        className={cn(styles.button, floating && styles.floating)}
        onClick={onRemove}
        title={t`Удалить поле`}
        aria-label={t`Удалить поле`}
    >
        <Delete width={14} height={14}/>
    </button>
);

export default RemoveFieldButton;
